import React, { FC } from 'react'

import { PageSectionBlock } from '../../layout_components/PageSectionBlock'
import { locale } from '../../locales/locale'
import HelpAutocomplete from '../HelpAutocomplete/HelpAutocomplete'
import { HeaderSearchProps } from './definitions'
import { SearchSectionContainer } from './header.components'

const HeaderSearchSection: FC<HeaderSearchProps> = (
  props: HeaderSearchProps
) => {
  return (
    <SearchSectionContainer>
      <PageSectionBlock>
        {!props.embedded && <h1>{locale('Supporto clienti')}</h1>}
        <div className={'subtitle'}>{locale('Ciao! Come possiamo aiutarti?')}</div>
        <HelpAutocomplete
          onChange={props.onChange}
          onSelect={props.onSelect}
          isExternal={false}
          internal={props.internal}
          onOpen={props.onOpen}
        />
      </PageSectionBlock>
    </SearchSectionContainer>
  )
}

export default HeaderSearchSection
